import { useQuery } from "@tanstack/react-query";
import { getCardsData, getCardsFullData, getTokensData } from "./api";
import { TOKEN_CARDS } from "@/utils/api/cardData/api";

export const useCardData = () => {
  return useQuery({
    queryFn: getCardsData,
    queryKey: ["card-data"],
    staleTime: Infinity,
  });
};

// export const useTokenData = () => {
//   return useQuery({
//     queryFn: getTokensData,
//     queryKey: ["token-data"],
//     staleTime: Infinity,
//   });
// };

export const useTokenData = () => {
  return useQuery({
    queryKey: ["token-data"],
    queryFn: async () => TOKEN_CARDS,
    staleTime: Infinity,
  });
};

export const useCardFullData = () => {
  return useQuery({
    queryFn: getCardsFullData,
    queryKey: ["card-data-full"],
    staleTime: Infinity,
  });
};
